import { FC } from 'react';
import classnames from 'classnames';

import Avatar, { AvatarProps } from '@z-components/atoms/Avatar';

import styles from './UserInformation.module.scss';

type AvatarPropParam = AvatarProps & { [additionalProps: string]: unknown };
interface Props {
  avatarProps?: AvatarPropParam;
  avatarRenderer?: FC<AvatarPropParam>;
  children: React.ReactNode;
  childrenStyles?:
    | Parameters<typeof classnames['default']>[0]
    | Parameters<typeof classnames['default']>;
}

const UserInformation: FC<Props> = ({
  children,
  avatarProps = {},
  avatarRenderer = Avatar,
  childrenStyles,
}) => (
  <div className={styles['user-information']}>
    <div className={styles['avatar-section']}>{avatarRenderer(avatarProps)}</div>
    <div className={classnames(styles['user-info'], childrenStyles)}>{children}</div>
  </div>
);

export type { Props as UserInformationProps };
export default UserInformation;
